module.exports = __webpack_public_path__ + "static/media/logo_RM_negativo.331be8f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo_RM_negativo.png
// module id = 614
// module chunks = 0